import { createContext, useContext, useEffect, useState, useRef } from "react";
import apiRequest from "../lib/apiRequest";
import { AuthContext } from "./AuthContext";



const inboxinterval = import.meta.env.VITE_INBOX_INTERVAL || 6000; // Default to 6 seconds if not set


export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {



  const [chats, setChats] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const { currentUser } = useContext(AuthContext);


  const intervalRef = useRef(null);


  useEffect(() => {
    if (currentUser) {
      startPolling();
    } else {
      stopPolling();
      setChats([]);         // optional: clear data
      setUnreadCount(0);    // optional: reset count
    }
    return () => stopPolling();
  }, [currentUser]);



  const fetchChats = async () => {
    try {

      if (!currentUser) return; // No user logged in
      const res = await apiRequest("/chats");
      // console.log("Chats fetched from context: ",res)

      if (!Array.isArray(res.data)) return;

      const parsed = res.data.map(chat => ({
        ...chat,
        otheruser: JSON.parse(chat.otheruser),
      }));
      setChats(parsed);
      const count = parsed.reduce((sum, chat) => sum + (chat.seen === "0" ? 1 : 0), 0);
      setUnreadCount(count);
      // console.log("Chats fetched:", parsed);
      // console.log("Unread count:", count);
    } catch (err) {
      console.error("Fetch chats failed", err);
    }
  };

  const startPolling = () => {
    fetchChats(); // Fetch immediately
    intervalRef.current = setInterval(fetchChats, inboxinterval);
  };

  const stopPolling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && currentUser) {
        startPolling();
      } else {
        stopPolling();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    // Start initially if tab is visible
    if (document.visibilityState === "visible" && currentUser) {
      startPolling();
    }
    return () => {
      stopPolling();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [currentUser]);

  return (
    <ChatContext.Provider value={{ chats, unreadCount, refreshChats: fetchChats }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => useContext(ChatContext);
